import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl, FormattedMessage } from 'react-intl';

import Checkbox from '../../common/Checkbox';
import { COLORS } from '../../../constants/styles';
import { PROFILE } from '../../../constants/strings';

import getLabel from '../utils/getLabel';

import styles from '../index.styl';

const labelStyle = {
  color: COLORS.grayDark,
  fontSize: 14,
};

const checkboxStyle = {
  marginBottom: 12,
};

const fieldWrapperStyle = {
  flexDirection: 'column',
  alignItems: 'flex-start',
};

const NotificationSettings = ({
  settings,
  onChange,
  intl: { formatMessage },
}) => (
  <section styleName="notification-settings">
    <h3 styleName="sectionTitle">
      <FormattedMessage {...PROFILE.notificationSettings.title} />
    </h3>
    <div styleName="fieldWrapper" style={fieldWrapperStyle}>
      {settings.map(({ type, value, enabled }) => (
        <Checkbox
          key={type}
          id={type}
          size={14}
          checked={enabled}
          label={getLabel(type, value, formatMessage)}
          labelStyle={labelStyle}
          style={checkboxStyle}
          onChange={val => onChange(type, val)}
        />
      ))}
    </div>
  </section>
);

NotificationSettings.propTypes = {
  settings: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.string,
      enabled: PropTypes.bool,
    }),
  ),
  onChange: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(NotificationSettings, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/NotificationSettings/index.jsx